import axios from "axios";
import { getLang, getlocalToken } from "./localstorage-service";
import * as constant from "./constants";
const hostUrl = constant.API_URL;

export function getToken(username, password) {
  const axiosNewConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  };
  return axios
    .post(`${hostUrl}/Token`, `grant_type=password&username=${username}&password=${password}`, axiosNewConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getUser() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/User/GetUser`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getCategories() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Category/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getVideo(categoryid, subcategoryid = null) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(
      `${hostUrl}/${getLang()}/Video/Get?categoryid=${categoryid}${
        subcategoryid == null ? "" : `&subcategoryid=${subcategoryid}`
      }`,
      axiosConfig
    )
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function updateUserProgress(data) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .put(`${hostUrl}/${getLang()}/UserProgress/Update`, JSON.stringify(data), axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function updateUser(data) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .put(`${hostUrl}/${getLang()}/User/Update`, JSON.stringify(data), axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getSubcategories() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Subcategory/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getMisc() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Misc/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getAssignment(subcategoryid) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Assignment/Get?subcategoryid=${subcategoryid}`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}
export function submitAssessment(data) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .post(`${hostUrl}/${getLang()}/Assignment/SubmitAssessment`, JSON.stringify(data), axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getCountries() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Country/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getStates() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/State/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getLanguages() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Language/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function register(data) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .post(`${hostUrl}/Account/Register`, JSON.stringify(data), axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function forgotPassword(emailAddress) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .get(`${hostUrl}/Account/ResetPwd?emailAddress=${emailAddress}`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function verifyEmail(id) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .get(`${hostUrl}/Account/VerifyEmail?id=${id}`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function resetPassword(data) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
  return axios
    .post(`${hostUrl}/Account/ResetPassword`, data, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}

export function getConstants() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${getlocalToken()}`
    }
  };
  return axios
    .get(`${hostUrl}/${getLang()}/Constant/Get`, axiosConfig)
    .then(response => {
      return response;
    })
    .catch(function(error) {
      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/data-service.js